import { JobFormValues } from '../components/EditEnrichedVacancyForm/EditEnrichedVacancy.types';

export const languageOptions: Array<{
  value: string;
  label: { en: string; nl: string };
}> = [
  { value: 'EN', label: { en: 'English', nl: 'Engels' } },
  { value: 'NL', label: { en: 'Dutch', nl: 'Nederlands' } },
  { value: 'DE', label: { en: 'German', nl: 'Duits' } },
  { value: 'FR', label: { en: 'French', nl: 'Frans' } },
  { value: 'IT', label: { en: 'Italian', nl: 'Italiaans' } },
  { value: 'ES', label: { en: 'Spanish', nl: 'Spaans' } },
  { value: 'PT', label: { en: 'Portuguese', nl: 'Portugees' } },
  { value: 'SE', label: { en: 'Swedish', nl: 'Zweeds' } },
  { value: 'NO', label: { en: 'Norwegian', nl: 'Noors' } },
  { value: 'DK', label: { en: 'Danish', nl: 'Deens' } },
  { value: 'FI', label: { en: 'Finnish', nl: 'Fins' } },
  { value: 'PL', label: { en: 'Polish', nl: 'Pools' } },
  { value: 'HU', label: { en: 'Hungarian', nl: 'Hongaars' } },
  { value: 'CZ', label: { en: 'Czech', nl: 'Tsjechisch' } },
  { value: 'SK', label: { en: 'Slovak', nl: 'Slovaaks' } },
  { value: 'BG', label: { en: 'Bulgarian', nl: 'Bulgaars' } },
  { value: 'HR', label: { en: 'Croatian', nl: 'Kroatisch' } },
  { value: 'RS', label: { en: 'Serbian', nl: 'Servisch' } },
  { value: 'RO', label: { en: 'Romanian', nl: 'Roemeens' } },
  { value: 'GR', label: { en: 'Greek', nl: 'Grieks' } },
  { value: 'RU', label: { en: 'Russian', nl: 'Russisch' } },
  { value: 'UA', label: { en: 'Ukrainian', nl: 'Oekraïens' } },
  { value: 'TR', label: { en: 'Turkish', nl: 'Turks' } },
  { value: 'MA', label: { en: 'Moroccan', nl: 'Marokkaans' } },
  { value: 'AR', label: { en: 'Arabic', nl: 'Arabisch' } },
  { value: 'CN', label: { en: 'Chinese', nl: 'Chinese' } },
  { value: 'EP', label: { en: 'Esperanto', nl: 'Esperanto' } },
];

export const EDUCATION_LEVELS = [
  { value: 'Not specified', label: { en: 'Not specified', nl: 'Niet gespecificeerd' } },
  { value: 'No formal education', label: { en: 'No formal education', nl: 'Ongeschoold' } },
  { value: 'Vmbo-BB/KB/G', label: { en: 'VMBO-BB/KB/G', nl: 'VMBO-BB/KB/G' } },
  { value: 'Vmbo-T', label: { en: 'VMBO-T', nl: 'VMBO-T' } },
  { value: 'Havo', label: { en: 'HAVO', nl: 'HAVO' } },
  { value: 'Vwo', label: { en: 'VWO', nl: 'VWO' } },
  { value: 'Mbo', label: { en: 'MBO', nl: 'MBO' } },
  { value: 'Hbo', label: { en: 'HBO', nl: 'HBO' } },
  { value: 'Wo', label: { en: 'WO', nl: 'WO' } },
];

export const EDUCATION_EQUIVALENTS = [
  { old: 'Basisberoepsgerichte leerweg', modern: 'Vmbo-BB/KB/G' },
  { old: 'vmbo-bb', modern: 'Vmbo-BB/KB/G' },
  { old: 'vmbo-basis', modern: 'Vmbo-BB/KB/G' },
  { old: 'Kaderberoepsgerichte leerweg', modern: 'Vmbo-BB/KB/G' },
  { old: 'vmbo-kb', modern: 'Vmbo-BB/KB/G' },
  { old: 'vmbo-kader', modern: 'Vmbo-BB/KB/G' },
  { old: 'Gemengde leerweg', modern: 'Vmbo-BB/KB/G' },
  { old: 'vmbo-g', modern: 'Vmbo-BB/KB/G' },
  { old: 'vmbo-gl', modern: 'Vmbo-BB/KB/G' },
  { old: 'Theoretische leerweg', modern: 'Vmbo-T' },
  { old: 'Vmbo', modern: 'Vmbo-T' },
  { old: 'vmbo-t', modern: 'Vmbo-T' },
  { old: 'vmbo-tl', modern: 'Vmbo-T' },
  { old: 'LBO', modern: 'Vmbo-T' },
  { old: 'VBO', modern: 'Vmbo-T' },
  { old: 'MAVO', modern: 'Vmbo-T' },
  { old: 'ULO', modern: 'Vmbo-T' },
  { old: 'MULO', modern: 'Vmbo-T' },
  { old: 'LEAO', modern: 'Vmbo-T' },
  { old: 'LHNO', modern: 'Vmbo-T' },
  { old: 'HBS', modern: 'Vwo' },
  { old: 'HTS', modern: 'Hbo' },
  { old: 'Kweekschool', modern: 'Hbo' },
  { old: 'Universiteit', modern: 'Wo' },
  { old: 'Wetenschappelijk onderwijs', modern: 'Wo' },
  { old: 'Associate degree', modern: 'Hbo' },
];

export const LANGUAGE_LEVELS = [
  { value: 'Not specified', label: { en: 'Not specified', nl: 'Niet gespecificeerd' } },
  { value: 'A1', label: { en: 'A1', nl: 'A1' } },
  { value: 'A2', label: { en: 'A2', nl: 'A2' } },
  { value: 'B1', label: { en: 'B1', nl: 'B1' } },
  { value: 'B2', label: { en: 'B2', nl: 'B2' } },
  { value: 'C1', label: { en: 'C1', nl: 'C1' } },
  { value: 'C2', label: { en: 'C2', nl: 'C2' } },
];

export const DRIVER_LICENSE_CATEGORIES = [
  { value: 'Not specified', label: { en: 'Not specified', nl: 'Niet gespecificeerd' } },
  { value: 'A', label: { en: 'A', nl: 'A' } },
  { value: 'A1', label: { en: 'A1', nl: 'A1' } },
  { value: 'A2', label: { en: 'A2', nl: 'A2' } },
  { value: 'AM', label: { en: 'AM', nl: 'AM' } },
  { value: 'B', label: { en: 'B', nl: 'B' } },
  { value: 'BE', label: { en: 'BE', nl: 'BE' } },
  { value: 'B+ (code 96)', label: { en: 'B+ (code 96)', nl: 'B+ (code 96)' } },
  { value: 'C', label: { en: 'C', nl: 'C' } },
  { value: 'CE', label: { en: 'CE', nl: 'CE' } },
  { value: 'C1', label: { en: 'C1', nl: 'C1' } },
  { value: 'C1E', label: { en: 'C1E', nl: 'C1E' } },
  { value: 'D', label: { en: 'D', nl: 'D' } },
  { value: 'DE', label: { en: 'DE', nl: 'DE' } },
  { value: 'D1', label: { en: 'D1', nl: 'D1' } },
  { value: 'D1E', label: { en: 'D1E', nl: 'D1E' } },
  { value: 'T', label: { en: 'T', nl: 'T' } },
];

export type EmploymentType =
  | 'fullTime'
  | 'temporary'
  | 'contract'
  | 'internship'
  | 'freelance'
  | 'seasonal'
  | 'apprenticeship'
  | 'temporaryAgencyWork';

export const employmentTypeOptions: Array<{
  value: EmploymentType;
  label: { en: string; nl: string };
  variations: { en: string[]; nl: string[] };
}> = [
  {
    value: 'fullTime',
    label: { en: 'Full Time', nl: 'Vast' },
    variations: {
      en: ['fulltime', 'full-time', 'permanent'],
      nl: ['voltijd', 'vast'],
    },
  },
  {
    value: 'temporary',
    label: { en: 'Temporary', nl: 'Tijdelijk' },
    variations: {
      en: ['temporary', 'temp', 'fixedterm'],
      nl: ['tijdelijk', 'flexibel'],
    },
  },
  {
    value: 'temporaryAgencyWork',
    label: { en: 'Temporary (staffing agency)', nl: 'Uitzenden' },
    variations: {
      en: ['temporary agency work', 'temp agency work', 'fixedterm agency work'],
      nl: ['uitzenden', 'uitzendwerk'],
    },
  },
  {
    value: 'contract',
    label: { en: 'Contract', nl: 'Detachering' },
    variations: {
      en: ['contract', 'contractor'],
      nl: ['detachering', 'uitzendwerk'],
    },
  },
  {
    value: 'internship',
    label: { en: 'Internship', nl: 'Stage' },
    variations: {
      en: ['internship', 'intern', 'trainee'],
      nl: ['stage', 'stagiair'],
    },
  },
  {
    value: 'freelance',
    label: { en: 'Freelance', nl: 'ZZP' },
    variations: {
      en: ['freelance', 'freelancer', 'selfemployed'],
      nl: ['zzp', 'zelfstandige', 'ondernemer'],
    },
  },
  {
    value: 'seasonal',
    label: { en: 'Seasonal', nl: 'Seizoenswerk' },
    variations: {
      en: ['seasonal', 'season'],
      nl: ['seizoenswerk', 'seizoen'],
    },
  },
  {
    value: 'apprenticeship',
    label: { en: 'Apprenticeship', nl: 'Leerling' },
    variations: {
      en: ['apprenticeship', 'apprentice'],
      nl: ['bbl', 'leerling', 'leerlingwezen'],
    },
  },
];

export const getEmploymentTypeVariations = (language: 'en' | 'nl'): string[] => {
  return employmentTypeOptions.flatMap((option) => option.variations[language]);
};

export const getEmploymentTypeLabel = (type: EmploymentType, language: 'en' | 'nl'): string => {
  return employmentTypeOptions.find((option) => option.value === type)?.label[language] ?? type;
};

export const getEducationLevelLabel = (level: string, language: 'en' | 'nl'): string => {
  // First check if this is an old value that needs to be mapped to a modern value
  const equivalent = EDUCATION_EQUIVALENTS.find((eq) => eq.old.toLowerCase() === level.toLowerCase());
  const modernLevel = equivalent ? equivalent.modern : level;

  // Then get the translated label for the modern value
  return EDUCATION_LEVELS.find((option) => option.value === modernLevel)?.label[language] ?? level;
};

export const getLanguageLabel = (lang: string, language: 'en' | 'nl'): string => {
  return languageOptions.find((option) => option.value.toUpperCase() === lang.toUpperCase())?.label[language] ?? lang;
};

export type WorkdayType = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export const workdayOptions: Array<{
  value: WorkdayType;
  label: { en: string; nl: string };
  variations: { en: string[]; nl: string[] };
}> = [
  {
    value: 'monday',
    label: { en: 'Monday', nl: 'Maandag' },
    variations: {
      en: ['monday', 'mon'],
      nl: ['maandag', 'ma'],
    },
  },
  {
    value: 'tuesday',
    label: { en: 'Tuesday', nl: 'Dinsdag' },
    variations: {
      en: ['tuesday', 'tue', 'tues'],
      nl: ['dinsdag', 'di'],
    },
  },
  {
    value: 'wednesday',
    label: { en: 'Wednesday', nl: 'Woensdag' },
    variations: {
      en: ['wednesday', 'wed'],
      nl: ['woensdag', 'wo'],
    },
  },
  {
    value: 'thursday',
    label: { en: 'Thursday', nl: 'Donderdag' },
    variations: {
      en: ['thursday', 'thu', 'thurs'],
      nl: ['donderdag', 'do'],
    },
  },
  {
    value: 'friday',
    label: { en: 'Friday', nl: 'Vrijdag' },
    variations: {
      en: ['friday', 'fri'],
      nl: ['vrijdag', 'vr'],
    },
  },
  {
    value: 'saturday',
    label: { en: 'Saturday', nl: 'Zaterdag' },
    variations: {
      en: ['saturday', 'sat'],
      nl: ['zaterdag', 'za'],
    },
  },
  {
    value: 'sunday',
    label: { en: 'Sunday', nl: 'Zondag' },
    variations: {
      en: ['sunday', 'sun'],
      nl: ['zondag', 'zo'],
    },
  },
];

// Special patterns that represent multiple days
export const workdayPatterns: Array<{
  pattern: string;
  days: WorkdayType[];
  variations: { en: string[]; nl: string[] };
}> = [
  {
    pattern: 'workdays',
    days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
    variations: {
      en: ['workdays', 'work days', 'working days', 'weekdays', 'week days'],
      nl: ['werkdagen', 'werk dagen', 'werkweek'],
    },
  },
  {
    pattern: 'weekend',
    days: ['saturday', 'sunday'],
    variations: {
      en: ['weekend', 'week end', 'week-end'],
      nl: ['weekend', 'weekeinde'],
    },
  },
  {
    pattern: 'monday-friday',
    days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
    variations: {
      en: ['monday-friday', 'monday to friday', 'mon-fri', 'mon to fri'],
      nl: ['maandag-vrijdag', 'maandag t/m vrijdag', 'maandag tot vrijdag', 'ma-vr', 'ma tot vr'],
    },
  },
  {
    pattern: 'saturday-sunday',
    days: ['saturday', 'sunday'],
    variations: {
      en: ['saturday-sunday', 'saturday to sunday', 'sat-sun', 'sat to sun'],
      nl: ['zaterdag-zondag', 'zaterdag tot zondag', 'za-zo', 'za tot zo'],
    },
  },
];

// Helper function to get all variations for a specific language
export const getWorkdayVariations = (language: 'en' | 'nl'): string[] => {
  return workdayOptions.flatMap((option) => option.variations[language]);
};

// Helper function to get label for a specific workday and language
export const getWorkdayLabel = (type: WorkdayType, language: 'en' | 'nl'): string => {
  return workdayOptions.find((option) => option.value === type)?.label[language] ?? type;
};

// Helper function to get weekdays (Monday to Friday)
export const getWeekdays = (): WorkdayType[] => {
  return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
};

export const shiftOptions = [
  { value: 'shiftDay', label: { en: 'Day shift', nl: 'Dagdienst' } },
  { value: 'shiftEvening', label: { en: 'Evening shift', nl: 'Avonddienst' } },
  { value: 'shiftNight', label: { en: 'Night shift', nl: 'Nachtdienst' } },
  { value: 'shift2Cycle', label: { en: '2-cycle shift', nl: '2 ploegen dienst' } },
  { value: 'shift3Cycle', label: { en: '3-cycle shift', nl: '3 ploegen dienst' } },
  { value: 'shift4Cycle', label: { en: '4-cycle shift', nl: '4 ploegen dienst' } },
  { value: 'shift5Cycle', label: { en: '5-cycle shift', nl: '5 ploegen dienst' } },
];

export const getShiftLabel = (shift: string, language: 'en' | 'nl'): string => {
  return shiftOptions.find((option) => option.value === shift)?.label[language] ?? shift;
};

export const DEFAULT_JOB_FORM_VALUES: JobFormValues = {
  job_details: {
    job_title: '',
    employment_type: [],
    min_salary: '',
    max_salary: '',
    salary_unit: '',
  },
  employment_requirements: {
    address: '',
    city: '',
    latitude: null,
    longitude: null,
    place_id: null,
    radius_km: 20,
    min_working_hours: '',
    max_working_hours: '',
    shifts: [],
    workdays: [],
  },
  position_overview: '',
  requirements: {
    minimum_education_level: '',
    maximum_language_skills: [],
    languages_level: '',
    certificates: '',
    drivers_license: [],
  },
  responsibilities: '',
  compensation_and_benefits: '',
};
